import { graphql } from '@api/generated';

export const getLiveServicesMappingsQuery = graphql(`
  query GetLiveServicesNumberMappings {
    liveServicesNumberMappings {
      phoneNumber
      tenantId
    }
  }
`);
